import { render, staticRenderFns } from "./netError.vue?vue&type=template&id=64640276&scoped=true&"
import script from "./netError.vue?vue&type=script&lang=js&"
export * from "./netError.vue?vue&type=script&lang=js&"
import style0 from "./netError.vue?vue&type=style&index=0&id=64640276&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64640276",
  null
  
)

export default component.exports